var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ordering-menu-homepage" }, [
    _c(
      "div",
      { staticClass: "top-container" },
      [
        _c(
          "el-carousel",
          {
            attrs: {
              interval: 4000,
              arrow: "never",
              height: "500px",
              "indicator-position": "none",
            },
          },
          _vm._l(_vm.carouselImages, function (item, index) {
            return _c("el-carousel-item", { key: index }, [
              _c("img", {
                staticClass: "carousel-image",
                attrs: { src: item, alt: "轮播图" },
              }),
            ])
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "menu-container" }, [
      _c("div", { staticClass: "user-container" }, [
        _c("div", { staticClass: "user-avatar-info" }, [
          _c("div", { staticClass: "avatar-container" }, [
            _c("img", {
              staticClass: "avatar-image",
              attrs: { src: _vm.userInfo.avatar, alt: "用户头像" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-name-container" }, [
            _c("div", { staticClass: "user-name" }, [
              _vm._v(_vm._s(_vm.userInfo.name)),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "member-level",
              attrs: { src: _vm.userInfo.memberLevelIcon, alt: "会员等级" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-info" }, [
            _c("div", { staticClass: "user-points" }, [
              _vm._v("积分:\n                        "),
              _c("span", { staticClass: "points" }, [
                _vm._v(_vm._s(_vm.userInfo.points)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-vouchers" }, [
              _vm._v("礼券:\n                        "),
              _c("span", { staticClass: "vouchers" }, [
                _vm._v(_vm._s(_vm.userInfo.vouchers)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-balance" }, [
              _vm._v("余额:\n                        "),
              _c("span", { staticClass: "balance" }, [
                _vm._v("¥" + _vm._s(_vm.userInfo.balance)),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "member-code-container" }, [
          _c("img", {
            staticClass: "member-code-image",
            attrs: { src: _vm.userInfo.memberCode, alt: "会员码" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-type-container" }, [
        _c(
          "div",
          {
            staticClass: "order-type-item order-type-dine-in",
            on: {
              click: function ($event) {
                return _vm.selectOrderType("dineIn")
              },
            },
          },
          [
            _c("img", {
              staticClass: "order-type-image",
              attrs: { src: _vm.orderTypes.dineIn.icon, alt: "堂食图标" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text" }, [_vm._v("堂食")]),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text-en" }, [
              _vm._v("Eat In"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "order-type-item order-type-takeaway",
            on: {
              click: function ($event) {
                return _vm.selectOrderType("takeaway")
              },
            },
          },
          [
            _c("img", {
              staticClass: "order-type-image",
              attrs: { src: _vm.orderTypes.takeaway.icon, alt: "自提图标" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text" }, [_vm._v("自提")]),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text-en" }, [_vm._v("To Go")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "order-type-item order-type-delivery",
            on: {
              click: function ($event) {
                return _vm.selectOrderType("delivery")
              },
            },
          },
          [
            _c("img", {
              staticClass: "order-type-image",
              attrs: { src: _vm.orderTypes.delivery.icon, alt: "外卖图标" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text" }, [_vm._v("外卖")]),
            _vm._v(" "),
            _c("div", { staticClass: "order-type-text-en" }, [
              _vm._v("Delivery"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "diamond-area" }, [
        _c(
          "div",
          {
            staticClass: "diamond-item pre-order-reserve",
            on: { click: _vm.handlePreOrder },
          },
          [
            _c("img", {
              staticClass: "diamond-icon",
              attrs: { src: _vm.diamondItems.reserve.icon, alt: "预点图标" },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "diamond-item pre-order-group",
            on: { click: _vm.handleGroupOrder },
          },
          [
            _c("img", {
              staticClass: "diamond-icon",
              attrs: { src: _vm.diamondItems.group.icon, alt: "拼单图标" },
            }),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "announcement-container" }, [
      _c("div", { staticClass: "announcement-content" }, [
        _c("div", { staticClass: "announcement-icon" }, [
          _c("img", {
            staticClass: "announcement-icon-image",
            attrs: { src: _vm.announcement.icon, alt: "公告图标" },
          }),
          _vm._v(" "),
          _vm.announcement.hasNew
            ? _c("span", { staticClass: "announcement-dot" })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "announcement-text" }, [
          _vm._v(_vm._s(_vm.announcement.text)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom-container" }, [
      _vm._v("\n        " + _vm._s(_vm.bottomText) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-container" }, [
      _c(
        "div",
        { staticClass: "footer-nav" },
        _vm._l(_vm.navItems, function (item) {
          return _c(
            "div",
            {
              key: item.name,
              staticClass: "nav-item",
              on: {
                click: function ($event) {
                  return _vm.handleNavClick(item)
                },
              },
            },
            [
              _c("img", {
                staticClass: "nav-icon",
                attrs: { src: item.icon, alt: item.name },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "nav-text" }, [
                _vm._v(_vm._s(item.name)),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "diamond-content" }, [
      _c("div", { staticClass: "diamond-title" }, [_vm._v("预点")]),
      _vm._v(" "),
      _c("div", { staticClass: "diamond-subtitle" }, [_vm._v("Pre-Order")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "diamond-content" }, [
      _c("div", { staticClass: "diamond-title" }, [_vm._v("拼单")]),
      _vm._v(" "),
      _c("div", { staticClass: "diamond-subtitle" }, [_vm._v("Group Order")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }